import React from "react";
import { PRAISE } from "../site-data";
import { Quote } from "lucide-react";

export default function Praise() {
  return (
    <section
      id="praise"
      data-testid="praise-section"
      className="relative py-24 lg:py-32 bg-[#1c1a1a] text-[#f9f6f0] overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1744056083470-3b7a223c5801)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="relative max-w-6xl mx-auto px-6 lg:px-10">
        <p className="eyebrow !text-[#e5c9c5] mb-5">Praise</p>
        <h2
          className="font-serif text-4xl lg:text-5xl tracking-tight text-[#f9f6f0] max-w-3xl"
          data-testid="praise-title"
        >
          Early words from readers who held these stories close.
        </h2>

        <div className="mt-14 grid md:grid-cols-3 gap-8">
          {PRAISE.map((p, i) => (
            <figure
              key={i}
              data-testid={`praise-card-${i}`}
              className="border border-[#4a4646] p-8 bg-[#1c1a1a]/60 backdrop-blur-sm"
            >
              <Quote className="text-[#e5c9c5]" size={22} />
              <blockquote className="mt-5 font-serif text-xl italic leading-snug text-[#f9f6f0]">
                {p.quote}
              </blockquote>
              <figcaption className="mt-6 eyebrow !text-[#e5c9c5]">
                — {p.source}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
